import { Helmet } from 'react-helmet-async';
import { compactJsonLd } from './jsonLd';

/**
 * Renders JSON-LD in document head. Pass one object or an array of schema objects.
 */
export function JsonLdScript({ data }) {
  const graph = compactJsonLd(Array.isArray(data) ? data : [data]);
  if (graph.length === 0) return null;

  const payload = graph.length === 1 ? graph[0] : graph;

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(payload)}</script>
    </Helmet>
  );
}
